

export const ROLES = ["Destek elemanı", "Çalışan temsilcisi", "İş güvenliği uzmanı", "İşyeri hekimi", "İlk yardım ekibi", "Yangınla mücadele ekibi", "Tahliye ekibi", "İSG kurul üyesi"];
export const HAZARDS = ["Az tehlikeli", "Tehlikeli", "Çok tehlikeli"];
export function sourceModuleAccess(role, permissions = {}) {
  if (["oluşturucu", "olusturucu", "creator"].includes(String(role).toLocaleLowerCase("tr-TR"))) return { personel: true, filo: true };
  const p = permissions.personeltakip || {};
  return { personel: !!((p.giris && (!p.yonetici || p.takip)) || (p.yonetici && !p.giris && !p.takip)), filo: permissions.filotakip?.takip === true || permissions.filotakip?.giris === true };
}
export { employeeCount, applicableRules, expiryFrom, effectiveRule, personEligibility, validateDefinition, definitionWarnings } from "../common/isgRuleEngine";
